var $3d83efd6529bcc21$exports = {};
$3d83efd6529bcc21$exports = {
    "Empty": `Prazno`
};


export {$3d83efd6529bcc21$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
